import { useFanes } from './use-fanes';

export function makeComponent<P>(token: string): React.FC<P> {
  return props => {
    const Comp = useFanes(s => s.use<P>(token));
    return <Comp {...props} />;
  };
}
